import { useMutation, useQueryClient } from '@tanstack/react-query'
import { putReportSourceById } from '@services/api/wizardAPI'
import { IReportBlueprint } from '@decoders/blueprintDecoder'

export interface IReportSourceMutation {
  sourceId: string
  reportSource: IReportBlueprint
}
export const useUpdateReportSourceMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ sourceId, reportSource }: IReportSourceMutation) =>
      putReportSourceById(sourceId, reportSource),
    onSettled: async (data, error, variables) => {
      await queryClient.invalidateQueries([
        'reportBlueprint',
        variables.sourceId,
      ])
      await queryClient.invalidateQueries(['products'])
    },
  })
}
